import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps, BasePageState } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
interface DownloadAppH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    thread?: ThreadAction;
}
interface DownloadAppH5PageState extends BasePageState {
    isJumpModal: boolean;
    downloadAppStatus: boolean; // 是否显示下载入口，用来记录下载入口的初始化状态，返回到其他页面后恢复下载入口的显示状态
    headerShowStatus: boolean;  // 是否显示header，用来记录header的初始化状态，返回到其他页面后恢复header的显示状态
    deepLink: string | null; // 来源页的深链接，用于打开APP后跳转到对应页面
}

@inject('app', 'site', 'user', 'thread')
@observer
class DownloadAppH5Page extends BasePage<DownloadAppH5PageProps, DownloadAppH5PageState> {
    private deepLinkTimer: number | null = null;
    private fallbackTimer: number | null = null;
    private openAttemptId = 0;
    private isOpeningApp = false;

    state: DownloadAppH5PageState = {
        isJumpModal: false,
        loading: false,
        error: null,
        pageLoaded: false,
        downloadAppStatus: false, // 是否显示下载入口
        headerShowStatus: false,  // 是否显示header
        deepLink: null,
    };
    componentDidMount() {
        const { app, user, thread, site } = this.props;
        // 读取来源页传入的深链接
        const searchParams = new URLSearchParams(this.props.location.search);
        const deepLinkParam = searchParams.get('deepLink');
        if (deepLinkParam) {
            this.setState({ deepLink: deepLinkParam } as any);
        }
        if (site) {
            // setTimeout(() => {
                this.setState({
                    downloadAppStatus: site.getAppDownloadShowStatus(),
                    headerShowStatus: site.getShowHeader(),

                }, () => {
                    site.setShowHeader(false);
                    site.setAppDownloadShowStatus(false);
                })
                
            // }, 100);
        }
        if (!this.isWeixin()) {
            const targetLink = deepLinkParam || 'vivoclub://com.vivo.club/deep?page=start';
            const attemptId = ++this.openAttemptId;
            this.deepLinkTimer = window.setTimeout(() => {
                if (attemptId !== this.openAttemptId) return;
                this.deepLinkTimer = null;
                window.location.href = targetLink;
            }, 500);
        }

        window.addEventListener('pagehide', this.handlePageHide);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        super.componentDidMount();
    }
    componentWillUnmount() {
        window.removeEventListener('pagehide', this.handlePageHide);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.handlePageHide();
        super.componentWillUnmount?.();

        let { downloadAppStatus, headerShowStatus} = this.state;
        const { site } = this.props;
        if(site) {
            site.setShowHeader(headerShowStatus);
            site.setAppDownloadShowStatus(downloadAppStatus);
        }
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return /android/.test(ua);
    }
    isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
    }

    // 清理唤起和下载兜底定时器
    handlePageHide = () => {
        if (this.deepLinkTimer !== null) {
            clearTimeout(this.deepLinkTimer);
            this.deepLinkTimer = null;
        }
        if (this.fallbackTimer !== null) {
            clearTimeout(this.fallbackTimer);
            this.fallbackTimer = null;
        }
        this.isOpeningApp = false;
    };

    handleVisibilityChange = () => {
        if (document.hidden) {
            this.handlePageHide();
        }
    };

    downloadApp() {
        if (!this.isAndroid()) {
            Toast.info({ content: '请在Android手机内打开此页面' });
            return;
        }
        if (this.isOpeningApp) return;

        const { deepLink } = this.state as DownloadAppH5PageState;
        const targetLink = deepLink || 'vivoclub://com.vivo.club/deep?page=start';

        if (this.isWeixin()) {
            this.setState({ isJumpModal: true } as any);
            return;
        }

        const attemptId = ++this.openAttemptId;
        this.handlePageHide();
        this.isOpeningApp = true;

        // 非微信环境，尝试唤起 APP，若未安装则回退到 apk 下载
        this.deepLinkTimer = window.setTimeout(() => {
            if (attemptId !== this.openAttemptId) return;
            this.deepLinkTimer = null;
            window.location.href = targetLink;
        }, 100);
        this.fallbackTimer = window.setTimeout(() => {
            if (attemptId !== this.openAttemptId) return;
            this.fallbackTimer = null;
            window.location.href = 'https://m.malink.cn/s/ABbE73';
        }, 1500);
        // 已在 componentDidMount 绑定 pagehide 到 handlePageHide
    }

    // 微信覆盖提示
    isWeixinXml() {
        return (
            <div className={styles.opAlertTable} onClick={() => {
                this.setState({ isJumpModal: false } as any);
            }}>
                <div className={styles.alertWhite}>
                    <div className={styles.inter}></div>
                    点击右上角选择在默认浏览器中打开！
                </div>
            </div>
        );
    }


    render() {
        return (
            <div className={styles.wrapper}>
                <div className={styles.downloadBox}>
                    <img src={`${BASE_IMG_URL}/common/app_logo.png`} alt="" className={styles.downloadLogo} />
                    {/* <div className={styles.downloadTitle}>vivo社区APP</div> */}
                    <img src={`${BASE_IMG_URL}/common/logo2.png`} alt="" className={styles.downloadSubLogo} />
                    <div className={styles.downloadTip}>与热爱同行</div>
                    {/* <img src={`${BASE_IMG_URL}/common/app_example.png`} alt="" className={styles.exampleImg} /> */}
                    <div className={styles.downloadBtn} onClick={() => this.downloadApp()}>打开APP</div>
                </div>
                {this.state.isJumpModal && this.isWeixinXml()}
            </div>
        );
    }
}

export default withRouter(DownloadAppH5Page);
